
import { Button } from "@portal/BaseComponents/Button/AntButton";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import useOpen from "@portal/hooks/useOpen";
import { Icon } from "@portal/lib/icons/icons";
import { useRef } from "react";
import { ActivitiesActionButtonProps } from "../type";
import { StatementContent } from "./PopOver/StatementContent";

const t = {
  title: "Statement",
};

interface DownloadStatementProps extends ActivitiesActionButtonProps {}

function DownloadStatement(props: DownloadStatementProps) {
  const { title = t.title, buttonProps, iconOnly, showToolTip } = props;
  const DownloadIcon = <Icon icon={['far','arrow-to-bottom']} />;
  const ref = useRef<HTMLDivElement>(null);
  const { open, toggleOpen, onClose } = useOpen({ open: false });
  function handlePopupContainer() {
    return ref.current as HTMLElement;
  }
  return (
    <StatementContent
      open={open}
      toggleOpen={toggleOpen}
      onClose={onClose}
      handlePopupContainer={handlePopupContainer}
    >
      <ToolTip open={showToolTip ? undefined : false}>
        <div ref={ref}>
          <Button icon={DownloadIcon} {...buttonProps} onClick={toggleOpen}>
            {iconOnly ? null : title}
          </Button>
        </div>
      </ToolTip>
    </StatementContent>
  );
}

export { DownloadStatement };
